export default __webpack_public_path__ + "static/DNGResidential_1-367bec3389b3a3ebf3838ef96547deea.jpg";